import { datatypes, inputTypes } from "data/globalData";
import {
	defRenderHeader,
	defRenderHeaderWithSX,
	PercentBackgroundColor,
	StandardRenderCellWithChildren,
	tableBorderStyle,
} from "../../data";
import { grey } from "@mui/material/colors";
import { convertValueInCr, roundDecimalValueUptoTwo } from "utils/roundDecimalValue";
import { reportModes } from "../../data";
import {
	calculateGpLostExcludingCm,
	calculateGpWithCmAchDiffAopPercentOfRev,
	calculateGpWithCmACHPercentOfRev,
	calculateGpWithCmAOPPercentOfRev,
	calculateGpWithCmGpLost,
	calculateGpWithoutCmAchDiffAopPercentOfRev,
	calculateGpWithoutCmACHPercentOfRev,
	calculateGpWithoutCmAOPPercentOfRev,
	calculateGpWithProjAchPercentExcludingCm,
	calculateGpWithProjAchPercentIncludingCm,
	calculateGpWithProjExcludingCm,
	calculateGpWithProjIncludingCm,
	calculateGpWithProjPercentOfRevAchPercentExcludingCm,
	calculateGpWithProjPercentOfRevAchPercentIncludingCm,
	calculateGpWithProjPercentOfRevIncludingCm,
} from "utils/calcultateAOPDataColumns";

export const gpDataColumns = {
	nsv_aop: { name: "NSV AOP", key: "nsv_aop" },
	nsv_ach: { name: "NSV ACH", key: "nsv_ach" },
};

const renderCellStyle = {
	boxSizing: "border-box",
	borderBottom: tableBorderStyle,
	borderRight: tableBorderStyle,
};
export const gpWithChMarginTableColumns = {
	gp_aop: {
		name: "AOP",
		key: "gp_aop",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,

		valueGetter: function (row, rawData = false) {
			if (rawData) return row["CM_GP_AOP_VAL"];
			else return convertValueInCr(row["CM_GP_AOP_VAL"]);
		},
		renderCell: function ({ row, field }) {
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					{this.valueGetter(row)}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "INR CR.",
	},
	gp_achieved: {
		name: "ACH",
		key: "gp_achieved",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },
		valueGetter: function (row, rawData = false) {
			if (rawData) return row["CM_GP_ACH_VAL"];
			else return convertValueInCr(row["CM_GP_ACH_VAL"]);
		},
		renderCell: function ({ row, field }) {
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					{this.valueGetter(row)}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "INR CR.",
	},
	gp_achieved_percent: {
		name: "ACH %",
		key: "gp_achieved_percent",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeaderWithSX({ borderRight: `2px solid ${grey[600]}`, boxSizing: "border-box", p: "2px" }),
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			const val = row["CM_GP_AOP_VAL"] > 0 && row["CM_GP_ACH_VAL"] ? (row["CM_GP_ACH_VAL"] / row["CM_GP_AOP_VAL"]) * 100 : 0;
			if (rawData) return val;
			else return roundDecimalValueUptoTwo(val);
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren
					field={field}
					row={row}
					sx={{ ...renderCellStyle, borderRight: `2px solid ${grey[600]}` }}>
					<PercentBackgroundColor value={val}>{val}</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "%",
	},
	gp_aop_percent_of_rev: {
		name: "AOP % of REV",
		key: "gp_aop_percent_of_rev",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithCmAOPPercentOfRev(row);
			else return roundDecimalValueUptoTwo(calculateGpWithCmAOPPercentOfRev(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},

		headerClassName: "default-header",
		unit: "% OF REV",
	},
	gp_ach_percent_of_rev: {
		name: "ACH % of REV",
		key: "gp_ach_percent_of_rev",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithCmACHPercentOfRev(row);
			else return roundDecimalValueUptoTwo(calculateGpWithCmACHPercentOfRev(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "% OF REV",
	},
	gp_ach_aop_precent_of_rev: {
		name: "ACH %",
		key: "gp_ach_aop_precent_of_rev",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeaderWithSX({ borderRight: `2px solid ${grey[600]}`, boxSizing: "border-box", p: "2px" }),
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithCmAchDiffAopPercentOfRev(row);
			else return roundDecimalValueUptoTwo(calculateGpWithCmAchDiffAopPercentOfRev(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren
					field={field}
					row={row}
					sx={{ ...renderCellStyle, borderRight: `2px solid ${grey[600]}` }}>
					<PercentBackgroundColor value={val}>{val}</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "%",
	},
	gp_with_proj: {
		name: "GP WITH PROJ",
		key: "gp_with_proj",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			return convertValueInCr(calculateGpWithProjIncludingCm(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "INR CR.",
	},
	gp_with_proj_ach_percent: {
		name: "ACH %",
		key: "gp_with_proj_ach_percent",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithProjAchPercentIncludingCm(row);
			else return roundDecimalValueUptoTwo(calculateGpWithProjAchPercentIncludingCm(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					<PercentBackgroundColor value={val}>{val}</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "%",
	},
	gp_with_proj_percent_of_rev: {
		name: "GP WITH PROJ % REV",
		key: "gp_with_proj_percent_of_rev",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithProjPercentOfRevIncludingCm(row);
			else return roundDecimalValueUptoTwo(calculateGpWithProjPercentOfRevIncludingCm(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "% OF REV",
	},
	gp_with_proj_percent_of_rev_ach_percent: {
		name: "ACH %",
		key: "gp_with_proj_percent_of_rev_ach_percent",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithProjPercentOfRevAchPercentIncludingCm(row);
			else return roundDecimalValueUptoTwo(calculateGpWithProjPercentOfRevAchPercentIncludingCm(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					<PercentBackgroundColor value={val} range="small">
						{val}
					</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "%",
	},
	gp_lost: {
		name: "GP LOST",
		key: "gp_lost",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithCmGpLost(row);
			else return convertValueInCr(calculateGpWithCmGpLost(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					<PercentBackgroundColor value={val} reverse={true}>
						{val}
					</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "INR CR.",
	},
};
export const gpWithoutChMarginTableColumns = {
	gp_aop: {
		name: "AOP",
		key: "gp_aop",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },
		valueGetter: function (row, rawData = false) {
			if (rawData) return row["GP_AOP_VAL"];
			return convertValueInCr(row["GP_AOP_VAL"]);
		},
		renderCell: function ({ row, field }) {
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					{this.valueGetter(row)}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "INR CR.",
	},
	gp_achieved: {
		name: "ACH",
		key: "gp_achieved",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return row["GP_ACH_VAL"];
			return convertValueInCr(row["GP_ACH_VAL"]);
		},
		renderCell: function ({ row, field }) {
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					{this.valueGetter(row)}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "INR CR.",
	},
	gp_achieved_percent: {
		name: "ACH %",
		key: "gp_achieved_percent",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeaderWithSX({ borderRight: `2px solid ${grey[600]}`, boxSizing: "border-box", p: "2px" }),
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			const val = row["GP_AOP_VAL"] > 0 && row["GP_ACH_VAL"] ? (row["GP_ACH_VAL"] / row["GP_AOP_VAL"]) * 100 : 0;
			if (rawData) return val;
			else return roundDecimalValueUptoTwo(val);
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren
					field={field}
					row={row}
					sx={{ ...renderCellStyle, borderRight: `2px solid ${grey[600]}` }}>
					<PercentBackgroundColor value={val}>{val}</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "%",
	},
	gp_aop_percent_of_rev: {
		name: "AOP % of REV",
		key: "gp_aop_percent_of_rev",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },
		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithoutCmAOPPercentOfRev(row);
			return roundDecimalValueUptoTwo(calculateGpWithoutCmAOPPercentOfRev(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={{ ...renderCellStyle }}>
					{/* <PercentBackgroundColor value={val}> */}
					{val}
					{/* </PercentBackgroundColor> */}
				</StandardRenderCellWithChildren>
			);
		},

		headerClassName: "default-header",
		unit: "% OF REV",
	},
	gp_ach_percent_of_rev: {
		name: "ACH % of REV",
		key: "gp_ach_percent_of_rev",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithoutCmACHPercentOfRev(row);
			return roundDecimalValueUptoTwo(calculateGpWithoutCmACHPercentOfRev(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "% OF REV",
	},
	gp_ach_aop_precent_of_rev: {
		name: "ACH %",
		key: "gp_ach_aop_precent_of_rev",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeaderWithSX({ borderRight: `2px solid ${grey[600]}`, boxSizing: "border-box", p: "2px" }),
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithoutCmAchDiffAopPercentOfRev(row);
			return roundDecimalValueUptoTwo(calculateGpWithoutCmAchDiffAopPercentOfRev(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren
					field={field}
					row={row}
					sx={{ ...renderCellStyle, borderRight: `2px solid ${grey[600]}` }}>
					<PercentBackgroundColor value={val} range="small">
						{val}
					</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "%",
	},
	gp_with_proj: {
		name: "GP WITH PROJ",
		key: "gp_with_proj",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithProjExcludingCm(row);
			return convertValueInCr(calculateGpWithProjExcludingCm(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={{ ...renderCellStyle }}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "INR CR.",
	},

	gp_with_proj_ach_percent: {
		name: "ACH %",
		key: "gp_with_proj_ach_percent",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithProjAchPercentExcludingCm(row);
			return roundDecimalValueUptoTwo(calculateGpWithProjAchPercentExcludingCm(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={{ ...renderCellStyle }}>
					<PercentBackgroundColor value={val}>{val}</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "%",
	},
	gp_with_proj_percent_of_rev: {
		name: "GP WITH PROJ % REV",
		key: "gp_with_proj_percent_of_rev",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },
		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithoutCmACHPercentOfRev(row);
			return roundDecimalValueUptoTwo(calculateGpWithoutCmACHPercentOfRev(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={{ ...renderCellStyle }}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "% OF REV",
	},
	gp_with_proj_percent_of_rev_ach_percent: {
		name: "ACH %",
		key: "gp_with_proj_percent_of_rev_ach_percent",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpWithProjPercentOfRevAchPercentExcludingCm(row);
			return roundDecimalValueUptoTwo(calculateGpWithProjPercentOfRevAchPercentExcludingCm(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={renderCellStyle}>
					<PercentBackgroundColor value={val} range="small">
						{val}
					</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "%",
	},

	gp_lost: {
		name: "GP LOST",
		key: "gp_lost",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		headerSx: { background: grey[500] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateGpLostExcludingCm(row);
			return convertValueInCr(calculateGpLostExcludingCm(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren field={field} row={row} sx={{ ...renderCellStyle }}>
					<PercentBackgroundColor reverse={true} value={val}>
						{val}
					</PercentBackgroundColor>
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "INR CR.",
	},
};

export const reportModeTableColumnsMap = {
	[reportModes.FINANCE.key]: gpWithoutChMarginTableColumns,
	[reportModes.OPS.key]: gpWithChMarginTableColumns,
};
